/* istanbul ignore file */

import { KeyboardEvent } from 'react';

export module KeydownOutsideDetector {

  export function attach(
    element: HTMLElement,
    downOutsideFn: (eventTarget: Element) => void,
    keysToListenTo: string[]
  ): () => void {
    const eventHanlder = (downEvent) => {
      const key = (downEvent as KeyboardEvent).key;
      if (keysToListenTo.includes(key)) {
        const target = downEvent.target;

        const containsElement = (currentElement: Element): boolean => {
          for (let i = 0; i < currentElement.children.length; i++) {
            if (currentElement.children[i] === target || containsElement(currentElement.children[i])) {
              return true;
            }
          }
          return false;
        };

        if (!containsElement(element)) {
          downOutsideFn(target as Element);
        }
      }
    };

    document.addEventListener('keydown', eventHanlder);

    return () => document.removeEventListener('keydown', eventHanlder);
  }

}